import React from 'react';
import TopNav from "../components/common/TopNav";

/**
 * Main layout component that wraps all pages and includes the LeftNav and TopNav
 * @param {Object} props - The component props
 * @returns {JSX.Element} The layout component
 */
const AppLayout = ({ children }) => {

  return (
    <div className="h-screen w-full flex flex-col bg-gradient-to-br from-[#1e1e1e] to-70% to-[#1f1b24]">
      {/* Top Navigation */}
      <TopNav />

      {/* Main Content */}
      <div className="flex-1 font-Poppins overflow-auto">
        {children}
      </div>
    </div>
  );
};

export default AppLayout;